import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ isResale?: boolean }>()(
  (theme, { isResale }) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    heading: {
      color: theme.palette.labraText.primary,
      fontSize: '18px',
      fontWeight: 400,
      lineHeight: '28px',
      paddingBottom: theme.spacing(0.5),
      width: '98%',
    },
    value: {
      color: theme.palette.labraText.description,
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      paddingBottom: theme.spacing(3),
    },
    outerWrapper: {
      display: 'flex',
      flexDirection: 'row',
      paddingBottom: theme.spacing(3),
    },
    customDimensionWrapper: {
      padding: theme.spacing(4, 4),
      border: `1px solid ${theme.palette.dividerV2.main}`,
      marginBottom: theme.spacing(3),
      borderRadius: '4px',
      boxSizing: 'border-box',
    },
    trashIcon: {
      color: theme.palette.labraIcon.main,
      cursor: 'pointer',
      width: '2%',
    },
    resourcesContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      gap: theme.spacing(4),
    },
    resouceField: {
      width: isResale ? '50%' : '33.3%',
    },
    innerWrapper: {},
    resouceFieldDown: {
      paddingTop: theme.spacing(2),
      width: '100%',
    },
    endHeading: {
      width: '213px',
      color: theme.palette.select.light,
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '20px',
      cursor: 'pointer',
    },
    widthButton: {
      width: 'fit-content',
      marginBottom: theme.spacing(1),
    },
    buttonSubText: {
      color: '#6A777A',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.25px',
    },
  })
)
